import { Badge, Button } from '@payaca/ambrosia';
import UntitledIcon from '@payaca/untitled-icons';
import { clstx } from '@payaca/utilities/cvaMerge';
import { motion } from 'motion/react';
import React, { FC } from 'react';
import tinycolor from 'tinycolor2';

export type TProps = {
  className?: string;
  isOpen: boolean;
  onToggle: (open: boolean) => void;
  stageName: string;
  stageValue: string;
  stageColour: string;
  childCount?: number;
};

const PipelineStageHeader: FC<TProps> = (props) => {
  const {
    className,
    isOpen,
    onToggle,
    stageName,
    stageValue,
    stageColour,
    childCount,
  } = props;

  return (
    <div className={className}>
      <div
        className={clstx(
          'flex justify-between items-center gap-2',
          !isOpen && 'flex-col'
        )}
      >
        <Badge.motion
          rounded
          layout="position"
          variant="custom"
          customColour={stageColour}
          className={clstx('gap-2', !isOpen && '[writing-mode:vertical-lr]')}
        >
          <div
            className={clstx(
              'self-stretch [padding-block:var(--spacing-1)] flex',
              isOpen ? 'w-2 h-auto' : 'w-auto h-2'
            )}
          >
            <div
              className="w-full h-full rounded"
              style={{
                backgroundColor: tinycolor(stageColour).isLight()
                  ? tinycolor(stageColour).darken(20).toString()
                  : tinycolor(stageColour).lighten(20).toString(),
              }}
            ></div>
          </div>
          {stageName}
        </Badge.motion>

        <Badge.motion
          rounded
          className="aspect-square justify-center"
          layout
          variant="white"
          size="sm"
        >
          {childCount}
        </Badge.motion>

        <Button.motion
          layout
          variant="white"
          size="xs"
          // Hidden on mobile — narrow viewports force stages open and rely on
          // horizontal swiping between them, so toggling adds no value.
          className={clstx(
            'aspect-square hidden md:inline-flex',
            isOpen ? 'ml-auto' : 'order-first'
          )}
          onClick={() => onToggle(!isOpen)}
        >
          <UntitledIcon
            className={clstx('w-5 h-5', isOpen && 'rotate-180')}
            name="chevron-right"
          />
        </Button.motion>
      </div>

      {isOpen && (
        <motion.p
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: 1,
          }}
          transition={{
            delay: 0.3,
          }}
          className="supporting-body text-gray-500 mt-2"
        >
          Value: {stageValue}
        </motion.p>
      )}
    </div>
  );
};

export default PipelineStageHeader;
